import { GSTIN_LIST, LOADER_STATUS, SELECTED_GSTIN, SELECTED_DATE, NOTICE_TABLE_DATA, TOTAL_PAGES, TOTAL_PAGES_HISTORY, SCHEDULER_TABLE_DATA, SEARCH, HISTORY_DATA, ENTITY_LIST, SELECTED_ENTITY, PROFILE_DATA, REF_IDS_LIST, NOTICE_TYPE_LIST, SELECTED, SELECTED_ROW, SELECTED_FROM_PERIOD, SELECTED_TO_PERIOD, SELECTED_ISSUE_DATE, SELECTED_DUE_DATE, NOTICE_TYPE_CODE_FILTER_LIST, REFERENCE_ID_FILTER_LIST } from "./constants";

export const initialState = {
  loaderStatus: false,
  gstinList: [],
  selectedGstin: null,
  selectedDate: null,
  noticeTableData: [],
  totalPages: 1,
  totalPagesHistory: 1,
  schedulerTableData: [],
  search: "",
  historyData: [],
  entityList: [],
  selectedEntity: "",
  profileData: [],
  refIdsList: [],
  noticeTypeList: [],
  selected: [],
  selectedRow: [],
  selectedFromPeriod: null,
  selectedToPeriod: null,
  selectedIssueDate: "",
  selectedDueDate: "",
  noticeTypeCodeFilterList: [],
  referenceIdFilterList: [],
};

/* eslint-disable default-case, no-param-reassign */
const noticeReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case GSTIN_LIST:
      return {
        ...state,
        gstinList: action.gstinList,
      };
    case SELECTED_GSTIN:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case SELECTED_DATE:
      return {
        ...state,
        selectedDate: action.selectedDate,
      };
    case NOTICE_TABLE_DATA:
      return {
        ...state,
        noticeTableData: action.noticeTableData,
      };
    case TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case TOTAL_PAGES_HISTORY:
      return {
        ...state,
        totalPagesHistory: action.totalPagesHistory,
      };
    case SCHEDULER_TABLE_DATA:
      return {
        ...state,
        schedulerTableData: action.schedulerTableData,
      };
    case SEARCH:
      return {
        ...state,
        search: action.search,
      };
    case HISTORY_DATA:
      return {
        ...state,
        historyData: action.historyData,
      };
    case ENTITY_LIST:
      return {
        ...state,
        entityList: action.entityList,
      };
    case SELECTED_ENTITY:
      return {
        ...state,
        selectedEntity: action.selectedEntity,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case REF_IDS_LIST:
      return {
        ...state,
        refIdsList: action.refIdsList,
      };
    case NOTICE_TYPE_LIST:
      return {
        ...state,
        noticeTypeList: action.noticeTypeList,
      };
    case SELECTED:
      return {
        ...state,
        selected: action.selected,
      };
    case SELECTED_ROW:
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case SELECTED_FROM_PERIOD:
      return {
        ...state,
        selectedFromPeriod: action.selectedFromPeriod,
      };
    case SELECTED_TO_PERIOD:
      return {
        ...state,
        selectedToPeriod: action.selectedToPeriod,
      };
    case SELECTED_ISSUE_DATE:
      return {
        ...state,
        selectedIssueDate: action.selectedIssueDate,
      };
    case SELECTED_DUE_DATE:
      return {
        ...state,
        selectedDueDate: action.selectedDueDate,
      };
    case NOTICE_TYPE_CODE_FILTER_LIST:
      return {
        ...state,
        noticeTypeCodeFilterList: action.noticeTypeCodeFilterList,
      };
    case REFERENCE_ID_FILTER_LIST:
      return {
        ...state,
        referenceIdFilterList: action.referenceIdFilterList,
      };
    default:
      return state;
  }
};

export default noticeReducer;
